import { render, staticRenderFns } from "./AddDbEmployee.vue?vue&type=template&id=13840d1a&"
import script from "./AddDbEmployee.vue?vue&type=script&lang=ts&"
export * from "./AddDbEmployee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports